import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPracticas, postPracticasPresupuesto,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRESUPUESTOS_ESTADOS } from "../../../../utils/constants";
import { PresupuestosPractica } from "../../Ingreso/PresupuestosPractica";
import { AutorizacionesAddPractica } from "../../Ingreso/AutorizacionesAddPractica";

export const PracticasMenuPresupuesto = (props) => {
  const dispatch = useDispatch();

  console.log(props.disabled);

  const { practicas = [], presupuestoSeleccionado = {} } = useSelector(
    (state) => state.autorizaciones
  );
  const [openAgregarPractica, setOpenAgregarPractica] = useState(false);

  useEffect(() => {
    dispatch(getPracticas(presupuestoSeleccionado.idTipoSolicitud));
  }, []);

  const onClickPracticasHandler = () => {
    const practicasFormateadas = practicas.map((practica) => {
      const materialesFormateados = practica.materiales?.map((material) => {
        return {
          idMaterial: material.idMaterial,
          cant: material.cantidad,
          valorUnitario: material.valorUnitario,
          recuperoSur: material.recuperoSur,
        };
      });

      return {
        idPresupuesto: practica.idPresupuesto,
        idCodNom: practica.idCodNom,
        cant: practica.cant,
        valorUnitario: practica.valorUnitario,
        materiales: materialesFormateados ? materialesFormateados : [],
        recuperoSur: practica.recuperoSur === null ? false : practica.recuperoSur,
      };
    });

    dispatch(
      postPracticasPresupuesto(
        { practicas: practicasFormateadas }
      )
    );
  };

  return (
    <React.Fragment>
      <div style={{ textAlign: "center", margin: "2rem 0" }}>
        {(presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
          || presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS)
          && !presupuestoSeleccionado.soloMateriales &&  (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenAgregarPractica(true)}
              disabled={presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS}
            >
              + Agregar Practica
            </Button>
          )}
      </div>
      {openAgregarPractica && !presupuestoSeleccionado.soloMateriales && (
        <AutorizacionesAddPractica
          postAgregar={() => setOpenAgregarPractica(false)}
          idTipoSolicitud={presupuestoSeleccionado?.idTipoSolicitud}
          permiteAgregarPracticaPeriodo={false}
        />
      )}
      <div style={{ margin: "2rem 0" }}>
        {Array.isArray(practicas) &&
          practicas?.length > 0 &&
          practicas.map((practica, index) => {
            return (
              <PresupuestosPractica
                key={index}
                practica={practica}
                desdeAuditar={props.desdeAuditar}
                disabled={presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS ? true : props.disabled}
              />
            );
          })}
      </div>
      <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <Button
          onClick={onClickPracticasHandler}
          disabled={presupuestoSeleccionado.idEstadoPresupuesto !==
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE &&
            presupuestoSeleccionado.idEstadoPresupuesto !==
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS}
          variant="contained"
          color="primary"
        >
          Guardar Cambios
        </Button>
      </div>
    </React.Fragment>
  );
};
